<template>
  <div>
    <div class="fixed top-0 left-0 right-0 z-10 flex flex-auto" ref="header">
      <zt-menu />
      <zt-header class="flex-1 flex" />
    </div>
    <div
      class="mt-10 pb-20 pt-16 lg:pb-0 lg:pt-20 lg:pl-6 xl:pl-6 md:pl-6 bg-white"
      ref="main"
    >
      <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-full mt-4">
        <div class="bg-white px-4">
          <div class="title_403"> {{$t('message.Errors.rrhhHandler.notPermission')}} </div>
        </div>
        <div class="h-64">
          <graphic-base height="100%" width="100%" :viewBox="'0 0 241 241'">
            <rrhhRedirect />
          </graphic-base>
        </div>
        <div class="bg-white py-10">
          <zt-button @click="goToAdmin">
            {{$t('message.Errors.rrhhHandler.buttonGoToAdmin')}}
          </zt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import ZtHeader from '@/components/Header'
import ZtMenu from '@/components/MenuBar'
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import rrhhRedirect from '@/components/commons/Illustrations/graphicSVG/rrhhRedirect'

export default {

  components: {
    ZtHeader,
    ZtMenu,
    graphicBase,
    rrhhRedirect,
  },
  methods: {
    goToAdmin(){
        location.replace(window.sichern.adminURL)
    }  
  },

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./public/assets/scss/_config.scss";

.title_403{
  width: 100%;
  font-size: 1.5em;
  text-align: center;
  color: $bluePrimary;
  font-weight: 500;
  margin: auto;
  margin-top: 1em;
}
</style>